import React from 'react';
import { Image } from '@mantine/core';
import TestsApi from "../../api/TestsApi";
import { IconX } from '@tabler/icons-react';
import { notifications } from '@mantine/notifications';
import { useNavigate } from "react-router-dom";

export function GridRotationPage({
  SelectedMemberWebsite,
  selectedFunnelRotationPage,
  rotationGridPageLists,
  SelectedThumbnail,
  SelectedThumbnailChange,
  }:any) {

  const navigate = useNavigate();

  const handleMultipleThumbnailClick = (pageId,pageClass) => {
    if(pageClass === 'page winner'){
      notifications.show({
        color: 'red',
        icon: <IconX size="1.1rem" />,
        title: 'Error',
        message: "You cannot add this page because this page has been selected as a winner in another funnel!",
      });
      return;
    } 

    if(pageClass === 'page draft'){
      notifications.show({
        color: 'red',
        icon: <IconX size="1.1rem" />,
        title: 'Error',
        message: "You cannot add this page because a draft test is set up on this page in another funnel!",
      });
      return;
    } 

    if(pageClass === 'page rotation'){
      notifications.show({
        color: 'red',
        icon: <IconX size="1.1rem" />,
        title: 'Error',
        message: "You cannot add this page because it is already selected as a rotation page in another funnel!",
      });
      return;
    } 

    if(pageClass === 'page discarded_by_cron'){
      notifications.show({
        color: 'red',
        icon: <IconX size="1.1rem" />,
        title: 'Error',
        message: "Already Test Completed on these pages!",
      });
      return;
    } 

    if(pageClass === 'page active test'){
      notifications.show({
        color: 'red',
        icon: <IconX size="1.1rem" />,
        title: 'Error',
        message: "Already active test on these pages!",
      });
      return;
    }

    TestsApi.selectrotationpagevalidation({
      system_website_id: SelectedMemberWebsite,
      page_id: pageId,
      funnel_id: selectedFunnelRotationPage,
    })
    .then((response) => {
      if (response.ok) {
        return response.json();
      } else {
        if (response.status === 401 || response.status === 400) {
          navigate('/logout');
        }
      }
    })
    .then((data) => {
      if (data.status === 1) {
        SelectedThumbnailChange((prevSelectedThumbnails) => {
          if (prevSelectedThumbnails.includes(pageId)) {
            return prevSelectedThumbnails.filter(id => id !== pageId);
          } else {
            return [...prevSelectedThumbnails, pageId];
          }
        });
      } else {
        notifications.show({
          color: 'red',
          icon: <IconX size="1.1rem" />,
          title: 'Error',
          message: data.message,
        });
      }
    })
    .catch((error) => {
      console.error('API Error:', error);
    });
  };

  return (
    <>
      {rotationGridPageLists.map((item, index) => (
          <div className="visi-page" key={index} style={{marginRight:13}} >
            <div className={item.pageClass}
                  style={{ cursor: 'pointer', backgroundColor: (item.selected || SelectedThumbnail.includes(item.pageId)) ? '#00b975' : '', userSelect: 'none' }} 
                  onClick={item.selected ? undefined : () => handleMultipleThumbnailClick(item.pageId,item.pageClass)}
                >
              <span title={item.pageURL}>
                <span className="page-url">{item.title}</span>
              </span>
              <div className="thumbnail" style={{ backgroundImage: `url(${'https://static.visiopt.com/page-thumb/'+item.imgURL})` }} title={item.pageURL}>
                {(item.marge_img !== '' && (
                    <Image
                    id="merge_img"
                    src={item.marge_img}
                    title="This Page is merged with other links"
                  />
                  ))
                }
                {(item.track_check !== '' && (
                  <Image
                    id="track_img"
                    src={item.track_check}
                    title={item.track_check_title}
                  />
                  ))
                }
              </div>
              <span className="page-title">{item.custom_title}</span>
            </div>
          </div>
      ))}
    </>
  );
}